<template>
  <section class="metric-paragraph">
    <div class="wrap-messages">
      <div
        v-for="(answer, $index) in question.answers"
        :key="$index"
        class="message"
      >
        <div class="author">
          <span>{{
            answer.name !== 'anonymous' ? answer.name : annonimousLabel
          }}</span>
          <div
            :class="{
              'material-icons custom-icon-incognito':
                answer.name === 'anonymous',
            }"
          ></div>
          <i
            v-if="answer.name !== 'anonymous'"
            class="material-icons account-circle"
          >
            account_circle
          </i>
        </div>
        <div class="text">{{ answer.text }}</div>
      </div>
    </div>

    <b-button
      variant="outline-primary btn-block"
      :disabled="question.answers.length === 0"
      @click="$router.push({ name: 'feedbacks.tickets' })"
    >
      {{ (labels.showAll || '').toUpperCase() }}
    </b-button>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'

const props = {
  question: {
    type: Object,
    required: true,
  },
  isEmpty: {
    type: Boolean,
    required: false,
  },
}

export default {
  props,
  computed: {
    ...mapGetters({ resources: 'resources' }),
    labels() {
      return this.resources.page.home.customPoll.report.questionMetric
    },
    annonimousLabel: function() {
      return this.resources.general.buttons.anonymous
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@/styles/custom/colors';

.metric-paragraph {
  p {
    color: map-get($theme-colors, 'gray04');
    font-size: 24px;
    font-weight: 500;
    padding: 0 1.4rem;
    margin: 0;
  }

  .btn-block {
    margin: 1.25rem auto;
    max-width: 278px;
  }

  .wrap-messages {
    align-items: flex-end;
    border-top: 1px solid map-get($theme-colors, 'gray07');
    border-bottom: 1px solid map-get($theme-colors, 'gray07');
    display: flex;
    flex-direction: column;
    height: 150px;
    overflow: auto;
    padding: 1.4rem;

    .message {
      max-width: 300px;
      margin: 10px 0;

      .author {
        align-items: baseline;
        color: map-get($theme-colors, 'primary');
        display: flex;
        font-size: 18px;
        font-weight: 500;
        justify-content: flex-end;
        margin-bottom: 5px;

        .mdi {
          align-items: center;
          background: map-get($theme-colors, 'gray07');
          border-radius: 50px;
          color: white;
          display: flex;
          font-size: xx-large;
          height: 40px;
          justify-content: center;
          margin-left: 10px;
          width: 40px;
        }
      }

      .text {
        background: map-get($theme-colors, 'primary');
        border-radius: 20px;
        color: white;
        padding: 1rem;
      }
    }
  }
}
</style>
